import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_virtual } from '@shared/dto/grid2d_virtual/DTO__grid2d_virtual';
import { UTILS__crypto } from '@shared/utils/crypto/UTILS__crypto';
import { Virtualizer } from '@tanstack/react-virtual';
import { MutableRefObject, useRef } from 'react';
import { use_effect } from '../../../../hooks/_base/use_effect';

interface Props {
  ref_item_heights: MutableRefObject<number[]>;
  grid2d_virtual: DTO__grid2d_virtual;
  grid2d: DTO__grid2d;
  ui_grid2d_cells_sort_newest_first: boolean;
  max_side: number;
  virtualizer: Virtualizer<HTMLDivElement, Element>;
}

export function HOOK_GRID2D__masonry_cell_heights({
  ref_item_heights,
  grid2d_virtual,
  grid2d,
  ui_grid2d_cells_sort_newest_first,
  max_side,
  virtualizer,
}: Props) {
  // index = grid2d cell index absolute
  const ref_hash = useRef(get_item_heights_hash([]));

  /*
   * EFFECTS
   */
  use_effect(() => try_recalculate_item_heights(), [virtualizer, grid2d_virtual.total_columns, grid2d, ui_grid2d_cells_sort_newest_first, max_side]);

  /*
   * METHODS
   */

  function try_recalculate_item_heights() {
    let cells_list_loaded_new = grid2d.cells__get_list(ui_grid2d_cells_sort_newest_first);

    let item_heights_new = cells_list_loaded_new.map(cell => cell.masonry_grid__get_cell_height(max_side));

    let item_heights_hash_new = get_item_heights_hash(item_heights_new);

    if (item_heights_hash_new === ref_hash.current) return;

    ref_hash.current = item_heights_hash_new;

    ref_item_heights.current = item_heights_new;

    virtualizer.measure();
  }

  function get_item_heights_hash(item_heights_new: number[]) {
    let object = {
      a: grid2d_virtual.total_columns,
      b: grid2d.total_cells_amount,
      c: ui_grid2d_cells_sort_newest_first,
      d: max_side,
      e: item_heights_new,
    };

    return UTILS__crypto.crc32.from_object(object);
  }

  return { try_recalculate_item_heights };
}
